import * as Yup from "yup";
import i18next from "i18next";

const password = (requiredMessage) => Yup.string()
    .required(requiredMessage)
    .test('blank', requiredMessage, (value) => !!value && value.trim().length > 0)
    .min(6, requiredMessage)
    .max(64, requiredMessage)

export const ChangePasswordSchema = () => Yup.object({
    old_password: Yup.string().required(i18next.t('profile.error_old_password')).test('blank', i18next.t('profile.error_old_password'), (value) => !!value && value.trim().length > 0),
    new_password: password(i18next.t('profile.error_new_password')),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('new_password'), null], i18next.t('profile.error_password_match'))
        .required(i18next.t('profile.error_confirm_password')),
});
